import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ContactForm from './components/ContactForm';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function ContactPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#inquiry-form') {
      setTimeout(() => {
        const el = document.getElementById('inquiry-form');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  const contactInfo = [
    {
      icon: 'ri-map-pin-line',
      label: '地址',
      value: '香港九龍紅磡馬頭圍道39號紅磡商業中心A座12樓1213室',
      href: null,
    },
    {
      icon: 'ri-phone-line',
      label: '電話',
      value: '2401 5938',
      href: 'tel:24015938',
    },
    {
      icon: 'ri-printer-line',
      label: '傳真',
      value: '9200 7917',
      href: null,
    },
    {
      icon: 'ri-mail-line',
      label: '電郵',
      value: 'info@coreunity.com.hk',
      href: 'mailto:info@coreunity.com.hk',
    },
    {
      icon: 'ri-global-line',
      label: '網址',
      value: 'www.coreunity.com.hk',
      href: 'https://www.coreunity.com.hk',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Banner */}
      <section className="relative pt-20 h-64 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/b8f4fee2b9cb78ba69b17629507601a8.jpg"
            alt="聯絡我們"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        </div>
        <div className="relative z-10 text-center">
          <div className="inline-block px-6 py-2 bg-orange-500 rounded-full mb-4">
            <span className="text-sm font-bold text-white tracking-wider">CONTACT US</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white">聯絡我們</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <div className="bg-orange-50 border-b border-orange-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-3 flex items-center space-x-2 text-sm">
          <Link to="/" className="text-orange-500 hover:text-orange-600 cursor-pointer whitespace-nowrap">首頁</Link>
          <i className="ri-arrow-right-s-line text-slate-400"></i>
          <span className="text-slate-600 whitespace-nowrap">聯絡我們</span>
        </div>
      </div>

      {/* Main Content */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

            {/* Left: Map + Contact Info */}
            <div className="space-y-8">
              <div>
                <div className="inline-block px-5 py-1.5 bg-orange-500 rounded-full mb-4">
                  <span className="text-xs font-bold text-white tracking-wider">OUR LOCATION</span>
                </div>
                <h2 className="text-3xl font-bold text-slate-900 mb-2">診所位置</h2>
                <div className="w-16 h-1 bg-gradient-to-r from-orange-500 to-orange-300 rounded-full"></div>
              </div>

              {/* Google Map */}
              <div className="w-full h-80 rounded-2xl overflow-hidden shadow-lg border border-orange-100">
                <iframe
                  title="康顧有限公司地圖"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.5!2d114.1833!3d22.3097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340400f5b3b3b3b3%3A0x0!2z6aaZ56eR5ZWG5qWt6YGT6Zmi6YGT5ZWG5qWt5ZWG5qWt!5e0!3m2!1szh-TW!2shk!4v1700000000000!5m2!1szh-TW!2shk&q=紅磡商業中心,馬頭圍道39號,紅磡,香港"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>

              {/* Contact Info Cards */}
              <div className="bg-gradient-to-br from-orange-50 to-white rounded-2xl p-8 border border-orange-100 shadow-md space-y-5">
                <h3 className="text-lg font-bold text-slate-900 mb-2">聯絡資訊</h3>
                {contactInfo.map((item) => (
                  <div key={item.label} className="flex items-start space-x-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-xl flex-shrink-0">
                      <i className={`${item.icon} text-lg text-white`}></i>
                    </div>
                    <div>
                      <p className="text-xs font-semibold text-orange-500 uppercase tracking-wider mb-0.5">{item.label}</p>
                      {item.href ? (
                        <a
                          href={item.href}
                          target={item.href.startsWith('http') ? '_blank' : undefined}
                          rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                          className="text-sm text-slate-700 hover:text-orange-500 transition-colors cursor-pointer"
                        >
                          {item.value}
                        </a>
                      ) : (
                        <p className="text-sm text-slate-700 leading-relaxed">{item.value}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Office Hours */}
              <div className="bg-white rounded-2xl p-8 border border-orange-100 shadow-md">
                <div className="flex items-center space-x-3 mb-5">
                  <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-xl">
                    <i className="ri-time-line text-lg text-white"></i>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900">辦公時間</h3>
                </div>
                <div className="space-y-3">
                  {[
                    { day: '星期一至五', time: '09:00 – 18:00' },
                    { day: '星期六', time: '09:00 – 13:00' },
                    { day: '星期日及公眾假期', time: '休息' },
                  ].map((row) => (
                    <div key={row.day} className="flex justify-between items-center py-2 border-b border-slate-100 last:border-0">
                      <span className="text-sm text-slate-600">{row.day}</span>
                      <span className={`text-sm font-semibold ${row.time === '休息' ? 'text-slate-400' : 'text-orange-500'}`}>{row.time}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right: Inquiry Form */}
            <div id="inquiry-form" className="space-y-8">
              <div>
                <div className="inline-block px-5 py-1.5 bg-orange-500 rounded-full mb-4">
                  <span className="text-xs font-bold text-white tracking-wider">SEND US A MESSAGE</span>
                </div>
                <h2 className="text-3xl font-bold text-slate-900 mb-2">發送查詢</h2>
                <div className="w-16 h-1 bg-gradient-to-r from-orange-500 to-orange-300 rounded-full mb-4"></div>
                <p className="text-slate-500 text-sm leading-relaxed">
                  如有任何查詢，歡迎填寫以下表格，我們的團隊將於2個工作天內與您聯絡。
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 border border-orange-100 shadow-md">
                <ContactForm />
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
